import { render, staticRenderFns } from "./taskListStore.vue?vue&type=template&id=e979e2ba"
import script from "./taskListStore.vue?vue&type=script&lang=js"
export * from "./taskListStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports